export const MAX_CSV_BYTES = 10 * 1000 * 1000;
export const MIN_SCHEDULE_MINUTES = 30;
export const PHONE_COLUMN = 'phone';
export const SENDER_COLUMN = 'sender';
export const MAX_PREVIEW_ROWS = 10;
export const MAX_LISTED_LINE_NUMBERS = 5;
export const S3_UPLOAD_TIMEOUT_MS = 120_000;

export const HEADER_MEDIA_BY_FORMAT = {
  IMAGE: {
    mimeTypes: ['image/jpeg', 'image/png'],
    maxBytes: 5 * 1024 * 1024,
    label: 'Comms image (JPG or PNG, max 5MB)',
    missingMessage: 'Add a comms image first.',
    wrongTypeMessage: 'Image must be JPG or PNG.',
    tooBigMessage: 'The comms image must be under 5MB.',
  },
  VIDEO: {
    mimeTypes: ['video/mp4'],
    maxBytes: 16 * 1024 * 1024,
    label: 'Comms video (MP4, max 16MB)',
    missingMessage: 'Add a comms video first.',
    wrongTypeMessage: 'Video must be MP4.',
    tooBigMessage: 'The comms video must be under 16MB.',
  },
} as const;

export const EMPTY_MEDIA_LABELS_FOR_NEW_SEND: Record<string, string> = {
  IMAGE: 'Add a comms image',
  VIDEO: 'Add a comms video',
};

export const EMPTY_MEDIA_LABELS_FOR_SENT_CAMPAIGN: Record<string, string> = {
  IMAGE: 'Comms image (not shown here)',
  VIDEO: 'Comms video (not shown here)',
};

export const WHATSAPP_COLORS = {
  header: '#008069',
  chatBg: '#efeae2',
  bubble: '#ffffff',
  text: '#111b21',
  meta: '#667781',
  link: '#027eb5',
  divider: '#e9edef',
  placeholder: '#dfe5e7',
} as const;
